<script>
    const axios = require('axios');
    import laroute from './../laroute';
    import trans from '../mixins/trans';

    export default {
        props: {
          companyFromItems: {
            type: String
          },
        },
        data() {
            return {
                laroute,
                total: 0.0,
                subtotal: 0.0,
                subtotal_net: 0.0,
                discount_amount: "",
                tax: 0.0,
                items: [],
                coupons: [],
                discountLabels: [],
                removedPriceRules: [],
                watchlist: [],
                showCouponForm: false,
                couponCode: "",
            }
        },

        mixins: [
            trans
        ],

        filters: {
            numberFormat(value) {
                return value.toFixed(2).replace('.', ',');
            }
        },

        mounted() {
            this.refresh();
        },

        methods: {
            refresh() {
                axios.get(laroute.route('api.basket.index'), {
                        params: {
                            diff_applied_rules: true,
                        }
                    })
                    .then(data => {
                        this.coupons = data.data.coupons;
                        this.items = data.data.items;
                        this.tax = data.data.tax;
                        this.total = data.data.total;
                        this.subtotal = data.data.subtotal;
                        this.subtotal_net = data.data.subtotal_net;
                        this.discount_amount = data.data.discount;
                        this.discountLabels = data.data.discountLabels;
                        this.removedPriceRules = data.data.removedPriceRules;
                        this.watchlist = data.data.watchlist;
                    });
            },

            deleteItem(rowId) {
                axios.delete(laroute.route('api.basket.destroy', {'training': rowId}))
                    .then(() => {

                        window.app.$refs.miniCart.update();
                        window.app.$refs.miniCart.$refs.cart.update()

                        this.refresh();
                    });
            },

            addCoupon() {
                axios.post(laroute.route('coupon.verify'), {
                    'code': this.couponCode
                })
                .then((response) => {
                    this.$notifications.success(this.__("The coupon has successfully been applied"));
                    this.couponCode = "";
                    this.refresh();
                })
                .catch(() => {
                    this.$notifications.error(this.__("The coupon code is invalid."));
                });
            },

            deleteCoupon(code) {
                axios.delete(laroute.route('api.basket.coupon.destroy'))
                    .then(() => {
                        window.app.$refs.miniCart.$refs.cart.update()

                        this.refresh();
                        this.showCouponForm = false;
                    });
            },

            toggleVoucher(item) {
                axios.put(laroute.route('api.basket.item.update', {'training': item.rowId}), {
                    'voucher': ! item.options.as_voucher
                }).then(() => {
                    this.refresh();
                });
            },

            updateQuantity(item) {
                axios.put(laroute.route('api.basket.item.update', {'training': item.rowId}), {
                    'qty': item.qty
                }).then(() => {
                    window.app.$refs.miniCart.update();

                    this.refresh();

                    const business = document.getElementById("business");

                    if(item.qty >= parseInt(this.companyFromItems)) {
                        business.style.display = "block";
                    }else {
                        business.style.display = "none";
                    }
                });
            },

            isOnWatchlist(item) {
                return this.watchlist.includes(item.id);
            },

            addToWatchlist(item) {
                axios.post(laroute.route('user.watchlist.store', {'training': item.options.slug}))
                .then((response) => {
                    this.$notifications.success(this.__("The course has been added to your watchlist."));
                    window.app.$refs.watchlist.update();
                    this.refresh();
                });
            }
        }
    };
</script>